var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uLoading: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-loading/u-loading" */ "uview-ui/components/u-loading/u-loading.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.showFileList
    ? _vm.__map(_vm.previewFileList, function (item, index) {
        var $orig = _vm.__get_orig(item)

        var f0 = _vm._f("hideTextCenter")(item.note, 30)

        return {
          $orig: $orig,
          f0: f0,
        }
      })
    : null

  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.isUploadDone ? _vm.handleUploadFile("image") : null
    }

    _vm.e1 = function ($event) {
      _vm.isUploadDone ? _vm.handleUploadFile("file") : null
    }
  }

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }